import { sendTo, setup } from 'xstate';

import type { StateActions, StateActors, StateChildren, StateContext, StateEvents, StateGuards } from './types';

export const machine = setup({
	/* oxlint-disable typescript/no-unsafe-type-assertion, typescript/no-unnecessary-type-assertion -- xstate setup() infers context/input/events from the {} literal; the cast is how these get typed at all */
	types: {
		context: {} as StateContext,
		events: {} as StateEvents,
		children: {} as StateChildren,
	},
	actions: {} as StateActions,
	guards: {} as StateGuards,
	actors: {} as StateActors,
	/* oxlint-enable typescript/no-unsafe-type-assertion, typescript/no-unnecessary-type-assertion */
}).createMachine({
	id: 'start-a-petition',
	initial: 'idle',
	context: ({ input }) => ({ ...input }),
	on: {
		sync_draft: {
			actions: ['syncDraft'],
		},
	},
	states: {
		idle: {
			always: [
				// place all variants before control, as control is the default fallback
				{ target: 'chatAgent', guard: 'isChatAgent' },
				// if no guards match, fallback to control
				{ target: 'control' },
			],
		},

		control: {
			invoke: {
				id: 'controlActorId',
				src: 'controlActorSrc',
				input: (input) => input.context,
			},
			on: {
				submit: {
					actions: sendTo('controlActorId', ({ event }) => event),
				},
				back: {
					actions: sendTo('controlActorId', ({ event }) => event),
				},
				error: {
					actions: sendTo('controlActorId', ({ event }) => event),
				},
			},
		},

		chatAgent: {
			invoke: {
				id: 'chatAgentActorId',
				src: 'chatAgentActorSrc',
				input: (input) => input.context,
			},
			on: {
				submit: {
					actions: sendTo('chatAgentActorId', ({ event }) => event),
				},
				back: {
					actions: sendTo('chatAgentActorId', ({ event }) => event),
				},
				error: {
					actions: sendTo('chatAgentActorId', ({ event }) => event),
				},
			},
		},
	},
});
